module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', _vm._g(_vm._b({
    attrs: {
      "disabled": _vm.disabled || _vm.loading
    }
  }, 'button', _vm.$attrs, false), _vm.$listeners), [(_vm.loading) ? _c('loader', {
    attrs: {
      "size": "small"
    }
  }) : _vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7bb5a82e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb5a82e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/buttons/LoadingButton.vue
// module id = 1772
// module chunks = 0